// src/pages/UniversalLedger/UniversalLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountBySeachApi } from "../../../apiservice/setting";
import { getUniversalLedgerApi } from "../../../apiservice/accounts";

// ─────────────────────────────────────────────────────────────────────────────
// FETCH LEDGER
// ─────────────────────────────────────────────────────────────────────────────
export const fetchUniversalLedger = createAsyncThunk(
  "universalLedger/fetchLedger",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters.accId,
        accTypeId: filters.accTypeId,
        dateFrom: filters.fromDate || null,
        dateTo: filters.toDate || null,
        ledgerType: filters.ledgerType || "without details",
      };
      const res = await getUniversalLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ─────────────────────────────────────────────────────────────────────────────
// SEARCH ACCOUNTS BY TYPE
// Reuses your existing /get-accounts-by-search endpoint.
// The multiType param filters accounts to the selected accTypeId only.
// ─────────────────────────────────────────────────────────────────────────────
export const fetchUniversalLedgerAccountsBySearch = createAsyncThunk(
  "universalLedger/fetchAccountsBySearch",
  async ({ search, accTypeId }, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search?.trim() || "",
        search: true,
        multiType: [accTypeId], // filters to the selected account type
      });
      // Normalize to the shape SearchListAutoComplete expects
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,      // SearchListAutoComplete uses sale_id as key
        display_text: c.acc_name,
        acc_id: c.acc_id,
        acc_name: c.acc_name,
        contact_no: c.contact_no || "",
        address: c.address || "",
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);